module.exports = __webpack_public_path__ + "static/carousel-new-lp-06-20-46357a64e80e7c781a86819f39a78672.png";